<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              class="min-button"
              @click="saveDriver()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-8">
          <div class="card">
            <h2 class="subtitle mb-4">Personal Info</h2>
            <div class="row">
              <div
                class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12 align-self-center"
              >
                <div class="row">
                  <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                    <base-input
                      id="first_name"
                      name="first_name"
                      v-model="driver.person.first_name"
                      label="First Name"
                      placeholder="First Name"
                      maxlength="45"
                      format="capitalize"
                      :error="
                        !$v.driver.person.first_name.minLength ||
                        $v.driver.person.first_name.$error
                          ? `Minimum  ${$v.driver.person.first_name.$params.minLength.min} letters.`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                    <base-input
                      id="last_name"
                      name="last_name"
                      v-model.trim="driver.person.last_name"
                      label="Last Name"
                      placeholder="Last Name"
                      maxlength="45"
                      format="capitalize"
                      :error="
                        !$v.driver.person.last_name.minLength ||
                        $v.driver.person.last_name.$error
                          ? `Minimum ${$v.driver.person.last_name.$params.minLength.min} letters.`
                          : ''
                      "
                    />
                  </div>

                  <div
                    class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-6"
                    v-bind:class="{
                      'is-invalid': $v.driver.person.gender.$error
                    }"
                  >
                    <label for="title" class="title-label">Gender</label>

                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio-group
                        v-model="$v.driver.person.gender.$model"
                        :aria-describedby="ariaDescribedby"
                        id="radio-gender"
                        name="radio-gender"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                      >
                        <b-form-radio value="male" class="pc-0">M</b-form-radio>
                        <b-form-radio value="female" class="pc-0"
                          >F</b-form-radio
                        >
                        <!-- <b-form-radio value="other" class="pc-0">X</b-form-radio> -->
                      </b-form-radio-group>
                    </b-form-group>

                    <small
                      class="invalid-feedback mt-1"
                      v-if="$v.driver.person.gender.$error"
                      >Select</small
                    >
                  </div>

                  <div class="col-xl-6 col-lg-3 col-md-6 col-sm-6 col-6">
                    <base-input
                      :error="
                        $v.driver.person.date_of_birth.$error
                          ? `You must be at least 18 years old`
                          : ''
                      "
                      addon-left-icon="ni ni-calendar-grid-58"
                      label="Date of Birth"
                      v-bind:class="{
                        'invalid-feedback-flatpicker':
                          $v.driver.person.date_of_birth.$error
                      }"
                    >
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          altFormat: formatDateFlatPicker,
                          altInput: true,
                          dateFormat: 'Y-m-d',
                          allowInput: true
                        }"
                        class="input-custom"
                        v-model="$v.driver.person.date_of_birth.$model"
                        placeholder="DD-MM-YYYY"
                        id="driver_birth"
                        name="driver_birth"
                      ></flat-picker>
                    </base-input>
                  </div>

                  <div
                    class="col-xl-6 col-lg-5 col-md-6 col-sm-6 col-12 inputphone mb-4"
                  >
                    <label
                      class="title-label"
                      v-bind:class="{
                        'is-invalid': $v.driver.person.numbre_phone.$error
                      }"
                      >Cell Phone</label
                    >
                    <vue-tel-input
                      v-model="phone_format"
                      key="NumberPhonedriver"
                      inputId="NumberPhonedriver"
                      name="NumberPhonedriver"
                      required
                      mode="international"
                      :wrapperClasses="[
                        $v.driver.person.numbre_phone.$error
                          ? 'is-invalid'
                          : '',
                        'mb-0'
                      ]"
                      inputClasses="input no-label no-err"
                      :dynamicPlaceholder="true"
                      :disabledFetchingCountry="true"
                      :validCharactersOnly="true"
                      @input="validateContactNumber"
                    ></vue-tel-input>
                    <small
                      class="invalid-feedback"
                      v-if="$v.driver.person.numbre_phone.$error"
                      >Enter a valid Phone Number</small
                    >
                  </div>

                  <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                    <base-input
                      id="imei"
                      name="imei"
                      v-model="driver.person.imei"
                      label="IMEI"
                      placeholder="IMEI"
                      maxlength="20"
                      :error="
                        !$v.driver.person.imei.minLength ||
                        $v.driver.person.imei.$error
                          ? `Minimum ${$v.driver.person.imei.$params.minLength.min} Numbers`
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 text-center align-self-center"
              >
                <label for="driver_ProfileImage" class="title-label-np mb-2">
                  Profile Image
                  <el-popover
                    placement="top"
                    trigger="hover"
                    width="300"
                    class="curp"
                  >
                    <ul class="ul-pop">
                      <li>Allowed Dimensions: 500 x 500 px</li>
                      <li>Maximum Size: 2MB</li>
                      <li>Allowed Formats: GIF,JPG,JPEG,PNG</li>
                    </ul>
                    <div class="badge badge-primary" slot="reference">
                      <span>?</span>
                    </div>
                  </el-popover>
                </label>
                <div>
                  <div class="imageload3">
                    <div class="image">
                      <div
                        v-if="selfile1"
                        v-bind:style="{
                          backgroundImage: 'url(' + imagePreview1 + ')'
                        }"
                        class="imgprofile"
                      ></div>

                      <div
                        v-else-if="driver.profile.image !== ''"
                        v-bind:style="{
                          backgroundImage: 'url(' + driver.profile.image + ')'
                        }"
                        class="imgprofile"
                      ></div>

                      <div
                        v-else
                        v-bind:style="{
                          backgroundImage: 'url(' + image_default_profile + ')'
                        }"
                        class="imgprofile"
                      ></div>
                    </div>
                    <div class="contentfile3">
                      <base-dropdown>
                        <base-button
                          slot="title-container"
                          type="primary"
                          class="dropdown-toggle btn-icon-only buttonfiles3"
                        >
                          <i class="flaticon-camera mr-0"></i>
                        </base-button>
                        <span class="dropdown-item">
                          <base-input
                            class="filebutton3"
                            type="file"
                            name="driver_ProfileImage"
                            id="driver_ProfileImage2"
                            :accesskey="'profile'"
                            enctype="multipart/form-data"
                            accept="image/jpeg, image/jpg, image/png"
                            @change="uploadFile"
                          ></base-input
                          >Upload Image
                        </span>
                        <span
                          class="dropdown-item"
                          v-if="selfile1"
                          @click="clearfile('profile')"
                          >Remove</span
                        >
                      </base-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle mb-4">Status</h2>
            <div class="row">
              <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12 mb-2">
                <WSelect
                  label="Type"
                  placeholder="Type"
                  v-bind:class="{
                    'invalid-feedback': $v.driver.relationship.type.$error
                  }"
                  v-model="driver.relationship.type"
                  id="type_status"
                  name="type_status"
                  style="width: 100%"
                >
                  <el-option
                    v-for="option in typeStatus"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </WSelect>
                <small
                  style="display: block"
                  class="invalid-feedback"
                  v-if="$v.driver.relationship.type.$error"
                  >Type is required</small
                >
              </div>

              <div class="col-xl-5 col-lg-4 col-md-5 col-sm-8 col-12 mb-2">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.driver.relationship.branch.$error
                  }"
                  label="Destination"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethodBranch"
                  :loading="loading"
                  placeholder="Enter a Destination"
                  v-model="driver.relationship.branch"
                  @change="selectBranch"
                  id="service_branch"
                  name="service_branch"
                  :error="
                    $v.driver.relationship.branch.$error
                      ? `Select a Destination `
                      : ''
                  "
                >
                  <el-option
                    v-for="branch in branches"
                    :value="branch._id"
                    :label="branch.name"
                    :key="branch._id"
                  >
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                        <span class="hide-data">{{ branch.name }}</span>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                        <span style="color: #8492a6" class="hide-data">
                          {{ branch.supplier.businessDetails.name }}
                        </span>
                      </div>
                    </div>
                  </el-option>
                </WSelect>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-7">
                <base-input
                  :error="
                    $v.driver.relationship.hire_date.$error
                      ? `Select Hire Date`
                      : ''
                  "
                  addon-left-icon="ni ni-calendar-grid-58"
                  label="Hire Date"
                  v-bind:class="{
                    'invalid-feedback-flatpicker':
                      $v.driver.relationship.hire_date.$error
                  }"
                >
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{
                      altFormat: formatDateFlatPicker,
                      altInput: true,
                      dateFormat: 'Y-m-d',
                      allowInput: true
                    }"
                    class="input-custom"
                    v-model="driver.relationship.hire_date"
                    placeholder="DD-MM-YYYY"
                    id="driver_hire_date"
                    name="driver_hire_date"
                  ></flat-picker>
                </base-input>
              </div>

              <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-5 form-group">
                <label class="title-label-np">Active</label>
                <base-switch v-model="driver.relationship.status"></base-switch>
              </div>

              <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-5 form-group">
                <label class="title-label-np">Auto Assign</label>
                <base-switch
                  v-model="driver.relationship.auto_assign"
                ></base-switch>
              </div>

              <div class="col-xl-4 col-lg-5 col-md-6 col-sm-6 col-12">
                <WSelect
                  placeholder="Vehicle"
                  v-model="driver.relationship.vehicle"
                  id="defaultVehicle"
                  name="defaultVehicle"
                  label="Default Vehicle"
                >
                  <el-option
                    v-for="(option, index) in vehiclesByBranchId"
                    :value="option._id"
                    :label="option.parameters.name"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
                        <span class="hide-data">
                          {{ option.parameters.name }}
                        </span>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                        <span style="color: #8492a6" class="hide-data">{{
                          option.information.licence
                        }}</span>
                      </div>
                    </div>
                  </el-option>
                </WSelect>
              </div>

              <div
                class="col-xl-5 col-lg-4 col-md-5 col-sm-7 col-12 form-group"
              >
                <label class="title-label">Assign Multiple Cars</label>
                <el-select
                  multiple
                  filterable
                  v-model="driver.relationship.vehicles"
                  id="otherVehicles"
                  name="otherVehicles"
                  class="select-multiple"
                  placeholder=""
                >
                  <el-option
                    v-for="(option, index) in vehicles"
                    :value="option._id"
                    :label="option.parameters.name"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
                        <span class="hide-data">
                          {{ option.parameters.name }}
                        </span>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                        <span style="color: #8492a6" class="hide-data">{{
                          option.information.licence
                        }}</span>
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle mb-4">Address Info</h2>
            <div class="row">
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-12">
                <base-input
                  id="driver_address"
                  name="driver_address"
                  label="Street address, apartment, suite, etc."
                  placeholder="Street address, apartment, suite, etc"
                  v-model="driver.address.street"
                  :error="
                    !$v.driver.address.street.minLength
                      ? `Minimum ${$v.driver.address.street.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                <base-input
                  id="driver_city"
                  name="driver_city"
                  label="City"
                  placeholder="City"
                  v-model="driver.address.city"
                  :error="
                    !$v.driver.address.city.minLength ||
                    $v.driver.address.city.$error
                      ? `Minimum ${$v.driver.address.city.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  id="driver_state"
                  name="driver_state"
                  label="State/Province/Region"
                  placeholder="State/Province/Region"
                  v-model="driver.address.state"
                  :error="
                    !$v.driver.address.state.minLength ||
                    $v.driver.address.state.$error
                      ? `Minimum ${$v.driver.address.state.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-5 col-md-5 col-sm-5 col-12">
                <base-input
                  id="driver_zipcode"
                  name="driver_zipcode"
                  label="Zip/Postal Code"
                  placeholder="Zip/Postal Code"
                  v-model.trim="driver.address.postal_code"
                  type="text"
                  :error="
                    !$v.driver.address.postal_code.minLength
                      ? `Minimum ${$v.driver.address.postal_code.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.driver.address.country.$error
                  }"
                  id="driver_country"
                  name="driver_country"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="Enter a Country"
                  v-model="driver.address.country"
                  label="Country"
                >
                  <el-option
                    v-for="(option, index) in optionsCountries"
                    :value="option.name"
                    :label="option.name"
                    :key="index"
                  ></el-option>
                </WSelect>
                <small
                  style="display: block"
                  class="invalid-feedback"
                  v-if="$v.driver.address.country.$error"
                  >Enter a Country</small
                >
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label class="title-label">House Phone</label>
                <vue-tel-input
                  v-model="housephone_format"
                  key="HousePhonedriver"
                  inputId="HousePhonedriver"
                  name="HousePhonedriver"
                  required
                  mode="international"
                  inputClasses="input no-label no-err"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  @input="validateContactHomeNumber"
                ></vue-tel-input>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-4">
          <div class="card">
            <h2 class="subtitle mb-4">Account Information</h2>
            <div class="row">
              <div class="col-xl-12 col-lg-7 col-md-8 col-sm-8 col-12">
                <base-input
                  id="driver_email"
                  name="driver_email"
                  v-model.trim="$v.driver.account.email.$model"
                  label="Email Address"
                  placeholder="Email Address"
                  :error="emailValidationMessage($v.driver.account.email)"
                  autocomplete="off"
                  :disabled="isEmailEmpty"
                />
              </div>

              <div class="col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12">
                <label
                  for="newPassword"
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.driver.account.password.$error
                  }"
                >
                  Password
                  <el-popover placement="top" trigger="hover" width="300">
                    <p class="form-control-label mb-2">
                      <i class="flaticon-lock-1 mr-2"></i>
                      <strong>Strong Password</strong>
                    </p>
                    <ul class="ul-pop">
                      <li>Minimum 8 characters</li>
                      <li>1 Uppercase Letter</li>
                      <li>1 Lowercase Letter</li>
                      <li>1 Number</li>
                      <li>1 Special Character (Ex. @ # $ %)</li>
                    </ul>
                    <div class="badge badge-primary ml-1" slot="reference">
                      <span>?</span>
                    </div>
                  </el-popover>
                </label>
                <base-input
                  class="input-append mb-0"
                  placeholder="Password"
                  v-bind:class="{
                    'is-invalid': $v.driver.account.password.$error
                  }"
                  v-model="$v.driver.account.password.$model"
                  :type="inputType"
                  name="password"
                  id="password"
                  autocomplete="new-password"
                  label="Password"
                  ><template slot="append">
                    <span @click="seePassword()" class="icon-button"
                      ><i
                        v-bind:class="{
                          'flaticon-view-1': inputType == 'password',
                          'flaticon-hidden': inputType == 'text'
                        }"
                      ></i
                    ></span>
                  </template>
                </base-input>
                <small
                  class="invalid-feedback mt-0"
                  v-if="$v.driver.account.password.$error"
                >
                  {{ passwordValidationMessage($v.driver.account.password) }}
                </small>
              </div>

              <div
                class="col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
              >
                <base-input
                  v-model.trim="$v.repeatPassword.$model"
                  label="Confirm Password"
                  placeholder="Confirm Password "
                  type="password"
                  id="confirm_password"
                  name="confirm_password"
                  :error="
                    !$v.repeatPassword.sameAsPassword ||
                    $v.repeatPassword.$error
                      ? `Passwords must be identical.`
                      : ''
                  "
                />
              </div>
              <div
                class="col-xl-12 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center alinmov2"
              >
                <base-button
                  type="outline-secondary"
                  class="min-button mb-4"
                  @click="autogeneratePass()"
                >
                  <i class="flaticon-bold-lock"></i>Generate Password
                </base-button>

                <base-button
                  type="outline-secondary"
                  class="min-button mb-4"
                  v-clipboard:copy="$v.driver.account.password.$model"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onErrorCopy"
                  v-if="$v.driver.account.password.$model"
                >
                  <i class="flaticon-copy"></i>Copy
                </base-button>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Info License</h2>
            <div class="row">
              <div
                class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 align-self-center"
              >
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                    <base-input
                      id="driver_license_number"
                      name="driver_license_number"
                      v-model.trim="driver.license.number"
                      label="License Number "
                      placeholder="Number"
                      maxlength="15"
                      :error="
                        !$v.driver.license.number.minLength ||
                        $v.driver.license.number.$error
                          ? `Minimum 5 characters.`
                          : ''
                      "
                    />
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                    <base-input
                      :error="
                        $v.driver.license.exppiration.$error
                          ? `The selected date must be greater than the current one`
                          : ''
                      "
                      addon-left-icon="ni ni-calendar-grid-58"
                      label="License Expiration"
                      v-bind:class="{
                        'invalid-feedback-flatpicker':
                          $v.driver.license.exppiration.$error
                      }"
                    >
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          altFormat: formatDateFlatPicker,
                          altInput: true,
                          dateFormat: 'Y-m-d',
                          allowInput: true
                        }"
                        class="input-custom"
                        v-model="driver.license.exppiration"
                        placeholder="DD-MM-YYYY"
                        id="driver_license_expiration"
                        name="driver_license_expiration"
                      ></flat-picker>
                    </base-input>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 text-center align-self-center"
              >
                <label for="licenseImage" class="title-label-np">
                  License Image
                  <el-popover
                    placement="top"
                    trigger="hover"
                    width="300"
                    class="curp"
                  >
                    <ul class="ul-pop">
                      <li>Allowed Dimensions: 500 x 500 px</li>
                      <li>Maximum Size: 2MB</li>
                      <li>Allowed Formats: GIF,JPG,JPEG,PNG</li>
                    </ul>
                    <div class="badge badge-primary" slot="reference">
                      <span>?</span>
                    </div>
                  </el-popover>
                </label>
                <div>
                  <div class="imageload2">
                    <div class="image">
                      <div
                        v-if="selfile2"
                        v-bind:style="{
                          backgroundImage: 'url(' + imagePreview2 + ')'
                        }"
                        class="imgLogoIcon"
                      ></div>

                      <div
                        v-else-if="driver.license.image !== ''"
                        v-bind:style="{
                          backgroundImage: 'url(' + driver.license.image + ')'
                        }"
                        class="imgLogoIcon"
                      ></div>

                      <div
                        v-else
                        v-bind:style="{
                          backgroundImage: 'url(' + image_default + ')'
                        }"
                        class="imgLogoIcon"
                      ></div>
                    </div>
                    <div class="contentfile2">
                      <base-dropdown menuOnRight>
                        <base-button
                          slot="title-container"
                          type="primary"
                          class="dropdown-toggle btn-icon-only buttonfiles2"
                        >
                          <i class="flaticon-camera mr-0"></i>
                        </base-button>
                        <span class="dropdown-item">
                          <base-input
                            class="filebutton2"
                            type="file"
                            name="imagepreview2"
                            id="imagepreview2"
                            :accesskey="'license'"
                            enctype="multipart/form-data"
                            accept="image/jpeg, image/jpg, image/png"
                            @change="uploadFile"
                          ></base-input
                          >Upload Image
                        </span>
                        <span
                          class="dropdown-item"
                          v-if="selfile2"
                          @click="clearfile('insurance')"
                          >Remove</span
                        >
                      </base-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alinmov2 mb-4">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button
          type="primary"
          class="min-button mb-0"
          @click="saveDriver()"
        >
          <i class="flaticon-floppy-disk"></i>Save
        </base-button>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
const {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  alpha,
  numeric,
  alphaNum
} = require("vuelidate/lib/validators");
import moment from "moment-timezone";
import lodash from "lodash";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import _URL from "../../Commons/URL/index";
import localHelper from "../Commons/Helper";
import WSelect from "@/components/Select";
import generator from "generate-password";
import upload from "../../Commons/Utility/Upload";
import path from "path";
import {
  goBack,
  unauthorizedAction,
  validateEmail
} from "../../../helpers/commons.helpers";
import {
  emailValidationMessage,
  passwordValidationMessage,
  validateBirthDate,
  validateLicenseDate
} from "../../../helpers/driver.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditDriver",
  data() {
    return {
      driver: {
        person: {
          first_name: "",
          last_name: "",
          full_name: "",
          gender: "",
          date_of_birth: "",
          imei: "",
          numbre_phone: ""
        },
        profile: {
          image: ""
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: "",
          house_phone: ""
        },
        license: {
          number: "",
          exppiration: "",
          image: ""
        },
        relationship: {
          type: "",
          branch: "",
          hire_date: "",
          status: false,
          duty: "off",
          vehicle: null,
          vehicles: [],
          auto_assign: false
        },
        account: {
          email: "",
          password: ""
        }
      },
      loading: false,
      branches: [],
      optionsCountries: [],
      phone_format: "",
      housephone_format: "",
      repeatPassword: "",
      saved: false,
      typeStatus: [
        { value: "in-house", label: "In house" },
        { value: "affiliate", label: "Affiliate" }
      ],
      imagePreview1: "",
      imagePreview2: "",
      selfile1: false,
      selfile2: false,
      image_default: `${_URL._PUB}/services/no-preview.png`,
      image_default_profile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      timezone: "",
      driverId: null,
      driverCopy: {},
      inputType: "password",
      lastEmail: "",
      isEmailEmpty: false
    };
  },
  async created() {
    this.setItemsBread([
      {
        text: "Drivers",
        to: "/drivers"
      },

      {
        text: "Edit Driver",
        active: true
      }
    ]);
    this.driverId = this.$route.params.id;
    this.getBranchesOptions();
    this.setLoad(true);
    await this.getDrivier(this.driverId);
    this.setLoad(false);
  },
  watch: {
    branchesOptions: {
      handler: function(current, old) {
        this.branches = current;
      },
      deep: true
    }
  },
  methods: {
    passwordValidationMessage,
    emailValidationMessage,
    async getDrivier(driverId) {
      try {
        let { data } = await endpoint.drivers.services.getOneDriver(
          driverId,
          this.sesion.token
        );
        if (data.status) {
          let driver = data.data;
          this.timezone = driver.relationship.branch.timezone;
          await this.getVehiclesByBranchId(driver.relationship.branch._id);

          this.driver.person.first_name = driver.person.first_name;
          this.driver.person.last_name = driver.person.last_name;
          this.driver.person.full_name = driver.person.full_name;
          this.driver.person.gender = driver.person.gender;
          this.driver.person.date_of_birth = moment(driver.person.date_of_birth)
            .utc()
            .format("YYYY-MM-DD");

          this.driver.person.imei = driver.person.imei;
          this.driver.person.numbre_phone = driver.person.numbre_phone;
          this.phone_format = this.driver.person.numbre_phone;

          this.driver.profile.image = driver.profile.image;

          this.driver.address.country = driver.address.country;
          this.driver.address.state = driver.address.state;
          this.driver.address.city = driver.address.city;
          this.driver.address.street = driver.address.city;
          this.driver.address.postal_code = driver.address.postal_code;
          this.driver.address.house_phone = driver.address.house_phone;
          this.housephone_format = this.driver.address.house_phone;

          this.driver.license.number = driver.license.number;
          this.driver.license.exppiration = moment(driver.license.exppiration)
            .utc()
            .format("YYYY-MM-DD");
          this.driver.license.image = driver.license.image;

          this.driver.relationship.type = driver.relationship.type;
          this.driver.relationship.branch = driver.relationship.branch._id;
          this.driver.relationship.hire_date = moment(
            driver.relationship.hire_date
          )
            .utc()
            .format("YYYY-MM-DD");
          this.driver.relationship.status = driver.relationship.status;
          this.driver.relationship.duty = driver.relationship.duty;
          this.driver.relationship.vehicle = driver.relationship.vehicle
            ? driver.relationship.vehicle._id
            : null;
          this.driver.relationship.vehicles = driver.relationship.vehicles;
          this.driver.relationship.auto_assign =
            driver.relationship.auto_assign;

          this.driver.account.email = driver.account.email;
          this.$v.driver.account.email.$model = driver.account.email;
          this.lastEmail = driver.account.email;
          this.isEmailEmpty = driver.account.email ? true : false;

          /**Copy value */
          this.driverCopy = lodash.cloneDeep(this.driver);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image can't be larger than 2MB or exceed 500 x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.driver.person.numbre_phone = result.number.e164;
        this.$v.driver.person.numbre_phone.$model = this.driver.person.numbre_phone;
      } else {
        this.driver.person.numbre_phone = value;
        this.$v.driver.person.numbre_phone.$model = value;
      }
    },
    validateContactHomeNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.driver.address.house_phone = result.number.e164;
      } else {
        this.driver.address.house_phone = value;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.optionsCountries = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.optionsCountries = [];
      }
    },
    remoteMethodBranch(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.branches = this.branchesOptions.filter(branch => {
            return branch.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.branches = [];
      }
    },
    async saveDriver(route = null) {
      if (!this.$v.driver.$invalid && !this.$v.repeatPassword.$invalid) {
        var driver = lodash.cloneDeep(this.driver);
        driver.person.date_of_birth = moment(driver.person.date_of_birth).tz(
          this.timezone
        );
        driver.license.exppiration = moment(driver.license.exppiration).tz(
          this.timezone
        );

        driver.relationship.hire_date = moment(
          driver.relationship.hire_date
        ).tz(this.timezone);

        driver.person.full_name = `${driver.person.first_name} ${driver.person.last_name}`;
        await this.updateDriver(this.driverId, driver, route);
      } else {
        this.$v.driver.$touch();
        this.$v.repeatPassword.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateDriver(driverId, driver, route = null) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.drivers.services.updateDriver(
          driverId,
          driver,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          this.saved = true;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Driver has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/drivers");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image can't be larger than 2MB or exceed 500 x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    uploadFile: async function(event) {
      const [file] = event.target.files;
      const toPreview = event.target.accessKey;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500 x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile(toPreview);
      } else {
        let urlFile = await upload.uploadFile(
          file,
          upload.buildQueryString(
            upload.getFileData(
              toPreview === "profile"
                ? "/drivers/avatars"
                : "/drivers/licenses",
              path.extname(file.name)
            )
          )
        );
        if (urlFile) {
          if (toPreview === "profile") {
            this.imagePreview1 = URL.createObjectURL(file);
            this.driver.profile.image = urlFile;
            this.selfile1 = true;
          } else {
            this.imagePreview2 = URL.createObjectURL(file);
            this.driver.license.image = urlFile;
            this.selfile2 = true;
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500 x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile: function(source) {
      if (source === "profile") {
        this.imagePreview1;
        this.driver.profile.image = "";
        this.selfile1 = false;
      } else {
        this.imagePreview2;
        this.driver.license.image = "";
        this.selfile2 = false;
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.driver.account.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The password has been copied to the clipboard",
        icon: "flaticon-remove"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The password could not be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.inputType = this.inputType == "password" ? "text" : "password";
    },
    selectBranch(branchId) {
      this.setVehiclesByBranchId([]);
      this.driver.relationship.vehicle = null;
      this.driver.relationship.vehicles = [];
      this.getVehiclesByBranchId(branchId);
    },
    goToPreviousPage() {
      goBack(this);
    },
    async detectChanges(to, from, next) {
      if (!this.sigout) {
        let isEqual = lodash.isEqual(this.driver, this.driverCopy);
        if (!isEqual && !this.saved) {
          let { value, dismiss } = await Swal.fire({
            title: "Important",
            html:
              "The Driver has been modified,<br> do you want to save changes?",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
            buttonsStyling: false,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            reverseButtons: true,
            cancelButtonText: "No",

            confirmButtonText: "Yes",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.saveDriver(to.path);
          } else if (dismiss === Swal.DismissReason.cancel) {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
    async verifyUserEmail() {
      try {
        let { data } = await endpoint.auth.services.validateEmail(
          this.driver.account.email
        );
        if (data.data) {
          return data.data.status;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    ...mapActions(["getBranchesOptions", "getVehiclesByBranchId"]),
    ...mapMutations([
      "setVehiclesByBranchId",
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDriversSearchCriteria"
    ])
  },
  validations: {
    driver: {
      person: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        date_of_birth: {
          required,
          validateBirthDate
        },
        imei: {
          minLength: minLength(14),
          maxLength: maxLength(20),
          alphaNum
        },
        numbre_phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        },
        gender: {
          required,
          minLength: minLength(2)
        }
      },
      relationship: {
        branch: {
          required
        },
        hire_date: {
          required
        },
        type: {
          required
        }
      },
      address: {
        country: {
          minLength: minLength(3),
          maxLength: maxLength(70)
        },
        state: {
          minLength: minLength(3)
        },
        city: {
          minLength: minLength(3)
        },
        street: {
          minLength: minLength(3)
        },
        postal_code: {
          minLength: minLength(4)
        }
      },
      license: {
        number: {
          required,
          minLength: minLength(5)
        },
        exppiration: {
          required,
          validateLicenseDate
        }
      },
      account: {
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (validateEmail(value)) {
              return this.lastEmail !== value
                ? await this.verifyUserEmail(value)
                : true;
            }
            return false;
          }
        },
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        }
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.driver.account.password;
      })
    }
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect
  },
  computed: {
    ...mapGetters([
      "countries",
      "branchesOptions",
      "sesion",
      "vehiclesByBranchId",
      "sigout",
      "settings"
    ]),
    vehicles: function() {
      return this.vehiclesByBranchId.filter(
        element => element._id !== this.driver.relationship.vehicle
      );
    },
    formatDateFlatPicker() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        }
        return "m/d/Y";
      }
      return "d-M-Y";
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInDriversModule(
      to.meta.modules,
      this.setDriversSearchCriteria,
      "drivers"
    );
    this.detectChanges(to, from, next);
  }
};
</script>
